module.exports = {
	"fileName": "/contracts/ConvertLib.sol",
	"name": "ConvertLib",
	"abi": [
		{
			"constant": false,
			"inputs": [
				{
					"name": "amount",
					"type": "uint256"
				},
				{
					"name": "conversionRate",
					"type": "uint256"
				}
			],
			"name": "convert",
			"outputs": [
				{
					"name": "convertedAmount",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function"
		}
	],
	"source": "pragma solidity ^0.4.2;\n\nlibrary ConvertLib{\n\tfunction convert(uint amount,uint conversionRate) returns (uint convertedAmount)\n\t{\n\t\treturn amount * conversionRate;\n\t}\n}\n",
	"abiDocs": [
		{
			"constant": false,
			"inputs": [
				{
					"name": "amount",
					"type": "uint256"
				},
				{
					"name": "conversionRate",
					"type": "uint256"
				}
			],
			"name": "convert",
			"outputs": [
				{
					"name": "convertedAmount",
					"type": "uint256"
				}
			],
			"payable": false,
			"type": "function",
			"signature": "convert(uint256,uint256)",
			"signatureHash": "96e4ee3d"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./docs/ConvertLib.json
// module id = 1080
// module chunks = 0